import { ErrorComponent } from "@components/ErrorComponent";
import { GoalIcon } from "@components/Goals/GoalIcon";
import { ListItem } from "@components/ListItem";
import { Loader } from "@components/Loader";
import { MainLayout, MainLayoutProps } from "@components/MainLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body } from "@components/Typography";
import { useContributionFlow, useUser } from "@hooks";
import { i18n, Translations } from "@i18n";
import { useNavigate } from "react-router-dom";
import { useStyles } from "./styles";

export const ContributionGoalRoute = () => {
  const styles = useStyles();

  const navigate = useNavigate();

  const { beneficiaries, loading, error } = useUser();

  const {
    contributionProps: { beneficiaryId },
    setContributionProps,
  } = useContributionFlow();

  const props: MainLayoutProps = {
    pageHeader: i18n.t(Translations.ContributionIndividualRouteHeader),
  };

  const goals = beneficiaries?.find((b) => b?.id === beneficiaryId)?.goals ?? [];

  if (loading) return <Loader />;
  if (error) return <ErrorComponent />;

  return (
    <MainLayout {...props}>
      <Body style={styles.text}>{i18n.t(Translations.ContributionGoalRouteTitle)}</Body>
      <Spacing size={SpacingSizes.M} />

      {goals.map((goal) => {
        if (!goal?.name || !goal?.id || !goal.type) {
          return null;
        }

        const onClick = () => {
          setContributionProps({
            goalId: goal.id!,
          });

          navigate(-1);
        };

        return (
          <>
            <ListItem
              title={goal.name}
              onClick={onClick}
              leftIcon={<GoalIcon type={goal.type} />}
            />
            <Spacing size={SpacingSizes.S} />
          </>
        );
      })}
    </MainLayout>
  );
};
